import { getBreakpoint } from './../utils/breakpoints';

$(window).on('load', function() {

$(".slick-applications").slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        arrows: true,
        draggable: false,
        responsive: [
            {
                breakpoint: getBreakpoint('sm'),
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    draggable: true,
                    dots: true,
                },
            },
        ],
    });
    $(".slick-products").slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        draggable: true,
        dots: true,
        adaptiveHeight: true,
    });

    if($('.slick-slideshow')){
        $(".slick-slideshow").slick({
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
            draggable: true,
            dots: false,
            adaptiveHeight: true
        });

        let total = parseInt(
            $(".slick-slideshow").slick("getSlick").slideCount
        );
        let current =
            parseInt($(".slick-slideshow").slick("slickCurrentSlide")) + 1;
        $(".slick--total").html(total);
        $(".slick--current").html(current);

        $(".slick-slideshow").on(
            "afterChange",
            (event, slick, currentSlide, nextSlide) => {
                let total = parseInt(
                    $(".slick-slideshow").slick("getSlick").slideCount
                );
                let current =
                    parseInt($(".slick-slideshow").slick("slickCurrentSlide")) + 1;
                $(".slick--total").html(total);
                $(".slick--current").html(current);
            }
        );
    }

    $('.applications-slideshow__slideshow').slick({
        mobileFirst: true,
        rows: 0,
        slidesToScroll: 1,
        slidesToShow: 2,
        arrows: false,
        dots: true,
        prevArrow: '<span class="slick__btn slick__btn--prev"><svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Home" transform="translate(-167.000000, -2099.000000)" stroke="#FFFFFF"><g id="Group-5" transform="translate(188.000000, 2120.000000) rotate(180.000000) translate(-188.000000, -2120.000000) translate(168.000000, 2100.000000)"><path d="M20,0 C31.046,0 40,8.954 40,20 C40,31.046 31.046,40 20,40 C8.954,40 0,31.046 0,20 C0,8.954 8.954,0 20,0" id="Fill-1"></path><path d="M16,27.4 L24,20.2 C24.2,20 24.2,19.8 24,19.8 L16,12.6" id="Stroke-3" stroke-linecap="round" stroke-linejoin="round"></path></g></g></g></svg></span>',
        nextArrow: '<span class="slick__btn slick__btn--next"><svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Home" transform="translate(-167.000000, -2099.000000)" stroke="#FFFFFF"><g id="Group-5" transform="translate(168.000000, 2100.000000)"><path d="M20,0 C31.046,0 40,8.954 40,20 C40,31.046 31.046,40 20,40 C8.954,40 0,31.046 0,20 C0,8.954 8.954,0 20,0" id="Fill-1"></path><path d="M16,27.4 L24,20.2 C24.2,20 24.2,19.8 24,19.8 L16,12.6" id="Stroke-3" stroke-linecap="round" stroke-linejoin="round"></path></g></g></g></svg></span>',
        appendArrows: $('.applications-slideshow__buttons'),
        slide: '.applications-slideshow__slide',
        infinite: true,
        draggable: false,
        responsive: [
            {
                breakpoint: getBreakpoint('lg'),
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    dots: false
                }
            }
        ]
    });

    $('.grid-layout__slideshow').slick({
        mobileFirst: true,
        rows: 0,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        dots: true,
        slide: '.grid-layout__slide',
        infinite: true,
        responsive: [
            {
                breakpoint: getBreakpoint('lg'),
                settings: 'unslick'
            }
        ]
    });
});

$(document).on("click", ".slick__btn--prev", e => {
	e.preventDefault();
	$(".slick-prev").click();
});

$(document).on("click", ".slick__btn--next", e => {
	e.preventDefault();
	$(".slick-next").click();
});
